import React from 'react'
import { connect } from 'react-redux'
import { openModal } from '../../../../action/positioned-modal-state'
import './index.scss'

const ProBlocker = props => {
  const { openModal, clickHandler, center } = props,
    btnClass = `pro-blocker-btn ${center ? 'center' : ''}`
  return (
    <div className='pro-blocker-bg'
      onClick={(e) => {
        e.stopPropagation()
        if (clickHandler) {
          clickHandler()
        } else {
          openModal({ subInfo: true })
        }
      }}>
      <div className={btnClass} style={{
        left: center ? '50%' : '',
        top: center ? '50%' : ''
      }}>
        Pro
      </div>
    </div>
  )
}

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({
  openModal: props => dispatch(openModal(props))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProBlocker)